import { cn } from '../utils/cn.js';

export default function DecorativeInput({
  containerClassName,
  className,
  variant,
  value,
  label,
}) {
  const variants = {
    portal: 'border-portal-foreground h-[46px] rounded-2xl',
  };

  return (
    <div className={cn('space-y-2', containerClassName)}>
      <p className="inline-block text-sm font-medium leading-none">{label}</p>

      <div
        className={cn(
          'flex min-h-10 w-full cursor-default items-center rounded-md border border-input bg-background px-3 py-2 text-sm outline-none',
          variants[variant],
          className,
        )}
      >
        {value}
      </div>
    </div>
  );
}
